import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { StatsCont } from './Statistics.styles';
import StatisticsBox from './StatisticsBox/StatisticsBox';
import { IStatTopicResults } from '../../services/reports';

interface IStatistics {
  data: {
    topTopics: IStatTopicResults;
    bottomTopics: IStatTopicResults;
    mostImprovedTopics: IStatTopicResults;
  } | null;
}

const Statistics: FC<IStatistics> = ({ data }) => {
  const { t } = useTranslation();

  const hasMostImprovedTopics =
    !_.isNull(data) && !_.isEmpty(data?.mostImprovedTopics?.topicResults);

  return (
    <>
      {!_.isEmpty(data?.bottomTopics) && !_.isEmpty(data?.topTopics) && (
        <StatsCont id="TopicsStatsCont">
          <StatisticsBox
            noDataText={t('report.topicsStats.noTopTopics')}
            name={t('report.topicsStats.topTopics')}
            description={data?.topTopics?.description || ''}
            results={data?.topTopics?.topicResults || []}
          />
          <StatisticsBox
            name={t('report.topicsStats.bottomTopics')}
            description={data?.bottomTopics?.description || ''}
            results={data?.bottomTopics?.topicResults || []}
          />
          {hasMostImprovedTopics ? (
            <StatisticsBox
              noDataText={t('report.topicsStats.noMostImprovedTopics')}
              name={t('report.topicsStats.mostImprovedTopics')}
              description={''}
              results={data.mostImprovedTopics.topicResults}
            />
          ) : null}
        </StatsCont>
      )}
    </>
  );
};

export default Statistics;
